<template>
	<div ref="idPan" style="height:100%;">
		<popwin style="width:100%; height:100%;" :ctrl="ctrlWin"></popwin>

		<div style="flex: 0 0 auto; width:100%; height:50px;">
			<div class="SiftPanel">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('硬件编码')}}</div>
				<input type="text" style="width:320px;" maxlength=40 v-model="findHdcode">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('设备名称')}}</div>
				<input type="text" style="width:120px;" maxlength=30 v-model="findDevName">

				<!--div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('授权方式')}}</div>
				<cselect style="position:relative; height:30px; min-width:80px; z-index:999;" :defv="findAuthType" v-model="findAuthType" :ctrl="ctrlAuthType" :csData="dataAuthType"></cselect-->

				<!--div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('权益')}}</div>
				<cselect style="position:relative; height:30px; min-width:80px; z-index:999;" :defv="findEquityLevel" v-model="findEquityLevel" :ctrl="ctrlEquityLevel" :csData="dataEquityLevel"></cselect-->

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onDevListClick"></div>
			</div>
		</div>

		<div ref="idTablePan" style="width:100%; border:0px solid red; display:flex; align-items:center;">
			<ctable :ctrl="ctrlTable"></ctable>
		</div>

		<div style="flex: 0 0 auto; width:100%; height:30px; border:0px solid red;">
			<cpage :key="keyFind" :ctrl="ctrlPage" style="margin-left:0px;"></cpage>
		</div>
	</div>
</template>

<script>

import ctable     from '../cf/ctable'
import popwin     from '../cf/popwin'
import cselect    from '../cf/cselect'
import cpage      from '../cf/cpage'

export default {
	name: 'devList',
	components:{
		ctable, popwin, cselect, cpage
	},
	data () {
		return {
			keyFind: 1000,
			findDevName: "",                        // 设备名称
			findHdcode: "",                         // 设备编码
			findEquityLevel: "132",                 // 权益等级
			/*ctrlEquityLevel:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},*/
			//findAuthType: 110,                      // 授权类型
			/*ctrlAuthType:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},*/
			ctrlPage: {
				havNote: true,                  //是否显示提示信息
				havGo: true,                    //是否显示页号输入及按钮
				total: 0,                       //总记录数
				pageSize: 100,                  //每页记录条数
				pageIdx: 0,                     //当前页码
				cont:[this.getLangText('共'),this.getLangText('条记录,'),this.getLangText('页'),this.getLangText('条/页'),this.getLangText('页码'),'Go'],
				qryFunc: this.onDevListClick,      //查询回调函数
			},

			ctrlWin:{                               // 弹出窗口控制属性
				w2: 500,
				h2: 440,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				rcallFunc: this.onDevListClick,                 // 指定关闭弹出窗后需要执行的回调方法
			},
			ctrlTable: {                            // 表格控制参数
				headHeight: 50,                     // 表头行的高度
				dataHeight: 46,                     // 数据行的高度
				isCheck: false,                     // 第一列, 是否显示为复选框
				isSplit: false,                     // 固定列、数据列、操作列间是否有渐变分隔
				dataHeads:{                         // 表格表头定义
					head1:[                         // 固定列表头
						{ capt:this.getLangText("硬件编码"), width:300 },
					],
					head2:[                         // 数据列表头
						{ width:120, capt:this.getLangText('客户') },
						{ width:100, capt:this.getLangText('状态') },
						{ width:120, capt:this.getLangText('纸张') },
						{ width:100, capt:this.getLangText('锁定') },
						{ width:120, capt:this.getLangText('网络') },
						{ width:160, capt:this.getLangText('支持离线') },
						{ width:120, capt:this.getLangText('有效期至') },
						//{ width:120, capt:this.getLangText('权益等级') },
						{ width:100, capt:this.getLangText('授权方式') },
						{ width:100, capt:this.getLangText('使用次数') },
						{ width:200, capt:this.getLangText('设备名称') },
						{ width:200, capt:this.getLangText('设备型号') },
						{ width:120, capt:this.getLangText('系统') },
						{ width:200, capt:this.getLangText('设备定位') },
						{ width:200, capt:this.getLangText('添加时间') },
						{ width:300, capt:'' },
					],
					head3:[                         // 操作列表头
						{ capt:this.getLangText('操作'), width:80 },
					],
				},
				datas:{ data1:[ ], data2:[ ], data3:[ ] },  // 表格数据定义
			},
		}
	},
	mounted: function(){
		if( !parseInt(this.login.userId) ) return;

		this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

		this.ctrlTable.self.show();

		this.onDevListClick();
	},
	computed:{

	},
	methods:{
		onResize: function( ){
			this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

			this.childResize( this );
		},
		/* 广告按钮事件响应 */
		onAdClick: function( param ){
			this.ctrlWin.w2 = 950;
			this.ctrlWin.h2 = 430;
			this.ctrlWin.captCont = LangText("广告");
			this.ctrlWin.vuepath = "/FrameBody/devList/adInfo";
			this.ctrlWin.info=param;
			this.ctrlWin.self.onShow();
		},
		/* 编辑按钮事件响应 */
		onEditClick: function( param ){
			this.ctrlWin.w2 = 500;
			this.ctrlWin.h2 = 580;
			this.ctrlWin.captCont = LangText("修改设备信息");
			this.ctrlWin.vuepath = "/FrameBody/devList/devInfo";
			this.ctrlWin.info=param;
			this.ctrlWin.self.onShow();
		},
		/* 移交按钮事件响应 */
		onDevoClick: function( param ){
			this.ctrlWin.w2 = 450;
			this.ctrlWin.h2 = 250;
			this.ctrlWin.captCont = LangText("移交设备");
			this.ctrlWin.vuepath = "/FrameBody/devList/devDevo";
			this.ctrlWin.info=param;
			this.ctrlWin.self.onShow();
		},
		/* 查询按钮事件响应 */
		onDevListClick: function(){
			let body={ pageSize:this.ctrlPage.pageSize, curPage:this.ctrlPage.pageIdx-1,
						devName: this.findDevName, devHdcode: this.findHdcode,
						devEquityLevel: parseInt(this.findEquityLevel),
						//devAuthType: parseInt(this.findAuthType)
					};

			this.doTrade( "POST", ServAddr+"/api/device/devList", this.onDevListOK, true, body, null );
		},
		onDevListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.ctrlTable.datas.data1=[];
			this.ctrlTable.datas.data2=[];
			this.ctrlTable.datas.data3=[];

			for(let i=0; i<data.body.devList.length; i++ )
			{
				let item=data.body.devList[i];
				this.ctrlTable.datas.data1.push([ item.devHdcode ]);

				let netSts=LangText("离线");
				if( item.deviceNetSts==1 ) netSts = LangText("在线");

				this.ctrlTable.datas.data2.push( [ item.devCustId ,this.getDevStsText(item.devSts), item.devicePaperPages,
							this.getForceText(item.deviceLock), netSts, this.getForceText(item.deviceMode),
							this.splitYMD(item.devValidate, 1),//this.getEquityText(item.devEquityLevel),
							this.getAutyTypeText(item.devAuthType),
							item.devUsedTimes, item.devName, item.devSerialno,
							item.devOs ? item.devOs:"", item.devLocate, item.devAddDatetime.substring(0,19), '' ] );

				let op1={capt: this.getLangText("编辑"), clk:this.onEditClick, param:item};
				let op2={capt: this.getLangText("移交"), clk:null, param:item};
				let op3={capt: this.getLangText("广告"), clk:this.onAdClick, param:item};

				if( this.login.userId == gPlatUserId )   // 只有平台管理员才能执行移交操作
				{
					op2.clk = this.onDevoClick;
				}

				if( this.login.custId == gPlatCustId )
					 this.ctrlTable.datas.data3.push([ [ op1, op2, op3 ] ]);
				else this.ctrlTable.datas.data3.push([ [ op1, op3 ] ]);
			}

			if( this.login.custId == gPlatCustId )
				 this.ctrlTable.dataHeads.head3[0].width = 250;
			else this.ctrlTable.dataHeads.head3[0].width = 160;

			this.ctrlTable.self.show();
			this.ctrlPage.total = data.body.allCnt;
			this.keyFind++;
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// devList.vue?7efb4e32